import { render, staticRenderFns } from "./ImagesTable.vue?vue&type=template&id=4a2f118d&scoped=true"
import script from "./ImagesTable.vue?vue&type=script&lang=js"
export * from "./ImagesTable.vue?vue&type=script&lang=js"
import style0 from "./ImagesTable.vue?vue&type=style&index=0&id=4a2f118d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f118d",
  null
  
)

export default component.exports